<template>
  <div class="com-step">
    <div class="step-progress">
      <template v-for="(item,index) in steps">
        <div class="step-wrap" :key="item">
          <span :class="[index===current-1?'f-red':'f-gray']">{{item}}</span>
          <div :class="['circle',index===current-1?'red':'gray']">{{index+1}}</div>
        </div>
        <div class="line" :key="index"></div>
      </template>
    </div>

    <div class="step-description" v-if="stepsDescription && stepsDescription.length > 0">
      <template v-for="(item, index) in stepsDescription">
        <div class="step-desc" :key="index">
          <span :class="[index===current-1?'f-red':'f-gray']">{{item}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model: 0
    }
  },
  name: 'step',
  model: {
    prop: 'current'
  },
  props: {
    current: {
      type: Number,
      default: 1
    },
    steps: Array,
    stepsDescription: Array
  },
  watch: {
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<style lang="less">
.com-step {
  vertical-align: bottom;
  text-align: center;
  .step-wrap {
    display: inline-block;
    text-align: center;
    width: 82px;

    .circle {
      width: 26px;
      height: 26px;
      border-radius: 13px;
      color: #fff;
      text-align: center;
      line-height: 26px;
      margin: 10px auto;
    }

    .red {
      background: @primary-color;
    }

    .gray {
      background: #808080;
    }

    .f-red {
      color: @primary-color;
    }

    .f-gray {
      color: #808080;
    }
  }
  .step-progress {
    .line {
      display: inline-block;
      width: 80px;
      height: 2px;
      background: #9f9f9f;
      margin-top: 42px;

      &:last-child {
        width: 0;
        height: 0;
      }
    }
  }
  .step-desc {
    display: inline-block;
    text-align: center;
    width: 155px;
    font-size: 13px;
    margin: 0 5px;
  }
}
@media only screen and (max-width: 768px) {
  .com-step {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
    .step-wrap {
      max-width: 82px;
      width: auto;
      font-size: 14px;
    }
    .step-progress {
      width: 100%;
      .line {
        width: 8%;
        flex: 1;
        &:last-child {
          flex: 0;
        }
      }
    }
  }
}
@media only screen and (max-width: 320px) {
  .com-step .step-progress .line {
    width: 20px;
  }
}
</style>
